export default __webpack_public_path__ + "static/img14h-654f95da9c061f65650441fc02d46d76.jpg";